"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var lib_1 = require("../../../../lib");
var index_1 = require("../../index");
var cronEnums_1 = require("../cronEnums");
var Months = [
    {
        value: "JAN",
        label: "January"
    },
    {
        value: "FEB",
        label: "February"
    },
    {
        value: "MAR",
        label: "March"
    },
    {
        value: "APR",
        label: "April"
    },
    {
        value: "MAY",
        label: "May"
    },
    {
        value: "JUN",
        label: "June"
    },
    {
        value: "JUL",
        label: "July"
    },
    {
        value: "AUG",
        label: "August"
    },
    {
        value: "SEP",
        label: "September"
    },
    {
        value: "OCT",
        label: "October"
    },
    {
        value: "NOV",
        label: "November"
    },
    {
        value: "DEC",
        label: "December"
    }
];
var MonthGenerator = /** @class */ (function (_super) {
    tslib_1.__extends(MonthGenerator, _super);
    function MonthGenerator(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onChangeMonthsOption = function (option) {
            _this.setState({ activeMonthButton: option });
            _this.generateCronMonth();
        };
        _this.onSelectSpecificMonth = function (months) {
            _this.setState({ specificMonths: (months.length > 0) ? months : ["JAN"] });
            _this.generateCronMonth();
        };
        _this.onSelectBetweenMonthFrom = function (e) {
            _this.setState({ betweenMonthFrom: e.target.value });
            _this.generateCronMonth();
        };
        _this.onSelectBetweenMonthTo = function (e) {
            _this.setState({ betweenMonthTo: e.target.value });
            _this.generateCronMonth();
        };
        _this.state = {
            activeMonthButton: cronEnums_1.MonthOptions.EveryMonth,
            specificMonths: ["JAN"],
            betweenMonthFrom: "JAN",
            betweenMonthTo: "DEC",
            cronMonth: "*",
        };
        return _this;
    }
    MonthGenerator.prototype.generateCronMonth = function () {
        var _this = this;
        setTimeout(function () {
            switch (_this.state.activeMonthButton) {
                case cronEnums_1.MonthOptions.EveryMonth:
                    _this.setState({ cronMonth: "*" });
                    break;
                case cronEnums_1.MonthOptions.SpecificMonth:
                    _this.setState({ cronMonth: _this.state.specificMonths.join(",") });
                    break;
                case cronEnums_1.MonthOptions.EveryMonthBetween:
                    _this.setState({ cronMonth: _this.state.betweenMonthFrom + "-" + _this.state.betweenMonthTo });
                    break;
            }
            _this.props.onGenerate(_this.state.cronMonth);
        }, 10);
    };
    MonthGenerator.prototype.render = function () {
        var theme = this.props.theme;
        var _a = this.state, activeMonthButton = _a.activeMonthButton, specificMonths = _a.specificMonths, betweenMonthFrom = _a.betweenMonthFrom, betweenMonthTo = _a.betweenMonthTo;
        return (React.createElement("div", null,
            React.createElement(lib_1.ButtonsGroup, { active: activeMonthButton, onChange: this.onChangeMonthsOption, borders: true },
                React.createElement(lib_1.GroupButton, { name: cronEnums_1.MonthOptions.EveryMonth }, "Every Month"),
                React.createElement(lib_1.GroupButton, { name: cronEnums_1.MonthOptions.SpecificMonth }, "Specific Month"),
                React.createElement(lib_1.GroupButton, { name: cronEnums_1.MonthOptions.EveryMonthBetween }, "Every Month Between")),
            activeMonthButton === cronEnums_1.MonthOptions.EveryMonth && (React.createElement("div", null,
                React.createElement(index_1.Label, { className: theme.label }, "Run Every Month"))),
            activeMonthButton === cronEnums_1.MonthOptions.SpecificMonth && (React.createElement("div", null,
                React.createElement(index_1.Label, { className: theme.label }, "Run On Specific Months"),
                React.createElement(index_1.MultiSelect, { surfaceLevel: 0, maxItems: 3, onSelectionChange: this.onSelectSpecificMonth, searchable: true, value: specificMonths, multiple: true, allowOnlySameGroupSelection: true },
                    React.createElement(index_1.MultiSelectGroup, { value: "selectAllMonths", label: "Select All Months" }, Months.map(function (month) { return (React.createElement(index_1.MultiSelectOption, { key: month.value, value: month.value, label: month.label })); }))))),
            activeMonthButton === cronEnums_1.MonthOptions.EveryMonthBetween && (React.createElement("div", null,
                React.createElement(index_1.Label, { className: theme.label }, "Run Every Month Between"),
                React.createElement("div", { className: theme.between },
                    React.createElement(lib_1.FormSelect, { className: theme.select, searchable: true, items: Months, maxItems: 5, value: betweenMonthFrom, onChange: this.onSelectBetweenMonthFrom, label: "From Month" }),
                    React.createElement(lib_1.FormSelect, { className: theme.select, searchable: true, items: Months, maxItems: 5, value: betweenMonthTo, onChange: this.onSelectBetweenMonthTo, label: "To Month" }))))));
    };
    MonthGenerator.defaultProps = {};
    return MonthGenerator;
}(React.Component));
exports.default = MonthGenerator;
